import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../api/client";
import { useAuth } from "../../context/AuthContext";
import "../../style/pages.css";
import "./Crops.css";

const initialForm = {
  code: "",
  name: "",
  level: 1,
  status: "미평가 (NE)",
  habitat: "",
  size: "",
  encounterCount: 1,
  asciiArt: "",
  description: "",
  weakness: "미확인",
  protocol: "",
  lastSeen: "",
};

export default function CropRegister() {
  const { user, csrfToken } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState(initialForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const update = (key) => (event) => setForm((current) => ({ ...current, [key]: event.target.value }));

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setSaving(true);
    try {
      const created = await api.createCrop(form, csrfToken);
      navigate(`/crops/${created.id}`);
    } catch (reason) {
      setError(reason.message);
    } finally {
      setSaving(false);
    }
  };

  if (user?.clearance < 3) {
    return (
      <div>
        <header className="page-head"><div><p className="eyebrow">ACCESS DENIED / CLEARANCE 03+</p><h1>크롭 기록 등록</h1></div></header>
        <section className="panel crop-clearance-denied"><p>현재 단말의 보안등급으로는 신규 개체 기록을 등록할 수 없습니다.</p><Link className="ghost-button" to="/crops">데이터베이스로 복귀</Link></section>
      </div>
    );
  }

  return (
    <div>
      <header className="page-head"><div><p className="eyebrow">NEW THREAT RECORD / CLEARANCE 03+</p><h1>신규 크롭 등록</h1></div><p>정찰 기록을 확인한 후 입력하십시오. 허위 정보 등록은 캠프 보안 규정에 따라 처리됩니다.</p></header>
      <section className="panel crop-register-panel">
        <form className="crop-register-form" onSubmit={submit}>
          {error && <div className="crop-register-error" role="alert">! {error}</div>}
          <div className="crop-form-grid">
            <div className="field"><label htmlFor="crop-code">개체 코드</label><input id="crop-code" value={form.code} onChange={(event) => setForm((current) => ({ ...current, code: event.target.value.toUpperCase() }))} placeholder="CRP-20" maxLength="8" pattern="CRP-[0-9]{2,4}" aria-describedby="crop-code-rule" required /><small className="field-help" id="crop-code-rule">규칙: CRP- + 숫자 2~4자리 · 영문은 대문자 고정 · 공백·한글·특수문자 사용 불가 · 기존 코드와 중복 불가<br />정상 예시: CRP-01, CRP-120, CRP-9999</small></div>
            <div className="field"><label htmlFor="crop-name">개체명</label><input id="crop-name" value={form.name} onChange={update("name")} maxLength="80" required /></div>
            <div className="field"><label htmlFor="crop-risk-level">위험 등급</label><select id="crop-risk-level" value={form.level} onChange={update("level")}>{Array.from({ length: 10 }, (_, index) => <option key={index + 1} value={index + 1}>L{index + 1}</option>)}</select></div>
            <div className="field"><label htmlFor="crop-status">상태 등급</label><select id="crop-status" value={form.status} onChange={update("status")}><option>절멸 (EX)</option><option>야생 절멸 (EW)</option><option>위급 (CR)</option><option>위기 (EN)</option><option>취약 (VU)</option><option>준위협 (NT)</option><option>최소관심 (LC)</option><option>정보부족 (DD)</option><option>미평가 (NE)</option></select></div>
            <div className="field"><label htmlFor="crop-habitat">주요 서식지</label><input id="crop-habitat" value={form.habitat} onChange={update("habitat")} maxLength="160" required /></div>
            <div className="field"><label htmlFor="crop-size">개체 크기</label><input id="crop-size" value={form.size} onChange={update("size")} maxLength="120" required /></div>
            <div className="field"><label htmlFor="crop-encounters">확인된 조우 횟수</label><input id="crop-encounters" type="number" min="0" max="999999" value={form.encounterCount} onChange={update("encounterCount")} required /></div>
            <div className="field"><label htmlFor="crop-last-seen">최종 목격 위치·시각</label><input id="crop-last-seen" value={form.lastSeen} onChange={update("lastSeen")} placeholder="GB-33-A 북동 방벽 / 10분 전" maxLength="160" required /></div>
            <div className="field field-wide"><label htmlFor="crop-ascii-art">개체 아스키아트</label><textarea className="ascii-art-input" id="crop-ascii-art" value={form.asciiArt} onChange={update("asciiArt")} rows="16" maxLength="50000" spellCheck="false" placeholder={"줄바꿈과 공백이 그대로 보존됩니다.\n아스키아트가 없으면 공통 식별 이미지가 표시됩니다."} /><small className="field-help">최대 50,000자 · 입력하지 않으면 기존 공통 아스키아트가 사용됩니다.</small></div>
            <div className="field field-wide"><label htmlFor="crop-description">개체 특징</label><textarea id="crop-description" value={form.description} onChange={update("description")} maxLength="10000" required /></div>
            <div className="field field-wide"><label htmlFor="crop-weakness">확인된 취약점</label><textarea id="crop-weakness" value={form.weakness} onChange={update("weakness")} maxLength="10000" required /></div>
            <div className="field field-wide"><label htmlFor="crop-protocol">대처법</label><textarea id="crop-protocol" value={form.protocol} onChange={update("protocol")} maxLength="10000" required /></div>
          </div>
          <div className="crop-register-actions"><Link className="ghost-button" to="/crops">등록 취소</Link><button className="primary-button" type="submit" disabled={saving}>{saving ? "기록 암호화 중..." : "크롭 기록 등록"}</button></div>
        </form>
      </section>
    </div>
  );
}
